<template>
  <div class="state-dropdown" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
          <option :value="null" v-show="currentValueDefined">Please Select</option>
          <option :value="undefined" v-show="!currentValueDefined">Please Select</option>
          <option v-for="val in values" :value="val.value" :key="val.id">{{val.display}}</option>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import fetchPortalJson from '@/js/PortalFetchJson'
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'StateDropDown',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
      states: []
    }
  },
  methods: {
    async getStates () {
      this.states = (await fetchPortalJson('states?consumer_id=' + this.consumerId)).states
    }
  },
  computed: {
    values () {
      return this.states
    }
  },
  mounted () {
    if (this.states.length <= 0) {
      this.getStates()
    }
  },
  watch: {
  }
}
</script>
